export default "__VITE_ASSET__BTfplzyn__"